; (function (jQuery) {

	"use strict";

	function Main()
	{
		var global = {
			navExpanded: false,
			modals: {
				element: false,
				focusedElementBeforeOpened: false
			},
		};

		var pub = {}

		var fn = {
			init: function ()
			{
				jQuery('.no-js').removeClass('no-js');

				// Header Menus

				// Initialise Menu
				// Sub Menu items not-tabbable
				jQuery('header .tabbed, .hd-login-row__buttons a.button').attr('tabindex', '-1');
				// Populate Mobile Menu
				fn.populateMobileMenu();

				// Mobile Menu Dropdown
				jQuery('header').on('click', '.mobile-nav-menu-btn', fn.handleMobileMenuExpansion);

				// Desktop Menu - Hide / Show Submenu
				jQuery('header').on('click', '.e-toggle-dropdown', fn.headerDropdown);

				// Toggle search dropdown on desktop, or nav menu on mobile
				// .js-trigger-search-dropdown link click
				jQuery('.js-trigger-search-dropdown').on('click', function(e)
				{
					e.preventDefault();

					const headerSearchToggle = jQuery('.header-options__item--search .e-toggle-dropdown');
					const mobileMenuToggle = jQuery('.mobile-nav-menu-btn');

					if (window.innerWidth >= 990)
					{ // from window width 990px, trigger the header search dropdown
						headerSearchToggle.trigger('click');
					}
					else
					{ // else trigger the mobile menu
						mobileMenuToggle.trigger('click');
					}
				});

				// Desktop Menu – Hide submenu when clicking outside (except .e-toggle-dropdown and .js-trigger-search-dropdown)
				jQuery(document).click(function (event)
				{
					if (!jQuery(event.target).closest('.e-toggle-dropdown').length && !jQuery(event.target).closest('.header-dropdown').length && !jQuery(event.target).closest('.js-trigger-search-dropdown').length)
					{
						fn.headerDropdownCloseAll();
					}
				});

				// Desktop Menu - Handle Hide / Show Key Presses
				jQuery('header').on('keydown', '.e-toggle-dropdown', function(e)
				{
					if (e.key === "ArrowDown")
					{
						if (jQuery(this).attr('aria-expanded') == "false")
						{
							e.preventDefault();
							fn.headerDropdown(e);
						}
					}
					if (e.key === "ArrowUp") {
						if (jQuery(this).attr('aria-expanded') == "true")
						{
							e.preventDefault();
							fn.headerDropdownCloseAll(e);
						}
					}
				});

				// Desktop Menu - Hide all on ESC
				jQuery(document).on('keyup', function(e) {
					if (e.key === "Escape")
					{
						fn.headerDropdownCloseAll();
					}
				});

				// Footer Menu Dropdown - Mobile Only
				jQuery('footer').on('click', '.footer-menu--mobile-dropdown .footer-menu__title', fn.handleMobileFooterMenuExpansion);

				// Trigger fitvids after BMCC plugin has replaced content
				jQuery('body').on('bmcc_embeds_and_iframes_replaced', function() {
					jQuery('main').fitVids({
						customSelector: 'iframe[data-src*="youtube.com"], iframe[data-src*="youtube-nocookie.com"]',
					});
				});

				// Match Height
				jQuery('.match-height').matchHeight();


				// Accordions
				jQuery('.accordion__title').on('click', fn.accordionToggle);
				jQuery('.accordion__title').on('keyup', function(e)
				{
					if (e.key === "Enter")
					{
						fn.accordionToggle(e);
					}
				});


				// Tab Key Focus - Adjust for Fixed header
				jQuery('main').on('focus', 'a[href], input, select, textarea, button, [tabindex]', fn.betterTabbing);


				// wForms (i.e. Form Assembly / Edge cert form) Page Scroll to top of form
				jQuery('main').on('click', '.wfPageNextButton, .wfPagePreviousButton', fn.scrollToFormTop);

				// wForms - Success page scroll to top of form
				let URLparams = (new URL(document.location)).searchParams;
				if (URLparams.has('tfa_next'))
				{
					const successString = URLparams.get('tfa_next');
					if (successString.includes('last_success'))
					{
						fn.scrollToFormTop();
					}
				}


				// Testimonial Sliders
				jQuery('.module-testimonial-slider .testimonials').each(fn.testimonialSlider);
				jQuery('.module-logo-slider .logos').each(fn.logoSlider);


				// News Filter & Pagination

					// News Filter - Hide / Show Post Variations button
					jQuery('.filter__button').on('click', fn.handleNewsFilter);
					jQuery('.filter__button').on('keyup', function(e)
					{
						if (e.key === "Enter")
						{
							fn.handleNewsFilter(e);
						}
					});

					// News Pagination - Show More News button
					jQuery('.post-teaser-more-button').on('click', fn.handleShowMoreNews);

					// General Pagination - Goto Page Form
					jQuery('.js-goto-form').on('submit', fn.paginationGoto);


				// News Side Bar Clone - for mobile
				fn.cloneSideBar();


				// Contact Map - Click - temp
				jQuery('.contact-map__pointer').on('click', function() {
					console.log('contact city pointer clicked');
				});

				// Modals
				pub.openGenericModal = fn.openGenericModal;
				pub.closeGenericModal = fn.closeGenericModal;

				jQuery(document).on('keydown', fn.modalKeyboardEvents);

				jQuery(document).ready(function ()
				{
					// Stakeholder Portal Modal
					if (jQuery('.js-portal-modal').length) {
						fn.openGenericModal(jQuery('.js-portal-modal')[0]);
					}

					jQuery('.js-close-portal-modal').on('click', fn.dismissPortalModal);
					jQuery('.portal-modal__close').on('click', fn.dismissPortalModal);
					jQuery('.portal-modal__btn--decline').on('click', fn.declinePortalModal);
					jQuery('.portal-modal').on('click', fn.consumeEvent);
				});

			},

			populateMobileMenu: function()
			{
				var langList = jQuery('.source-lang-list');
				var loginButtons = jQuery('.source-login-buttons');
				langList.clone().appendTo('.dest-lang-list');
				loginButtons.clone().appendTo('.dest-login-buttons');
			},

			handleMobileMenuExpansion: function(e)
			{
				e.preventDefault();
				var navBarMenu = jQuery('.header-nav');
				var navBarButtons = jQuery('.mobile-nav-menu-btn');
				if (!global.navExpanded)
				{
					global.navExpanded = true;
					navBarMenu.addClass('header-nav--active');
					navBarButtons.attr('aria-expanded', 'true');
				}
				else
				{
					global.navExpanded = false;
					navBarMenu.removeClass('header-nav--active');
					navBarButtons.attr('aria-expanded', 'false');
				}
			},

			headerDropdown: function(e)
			{
				e.preventDefault();
				// Aria - set all dropdowns as closed
				jQuery('.e-toggle-dropdown').attr('aria-expanded', false);
				var dropdown = jQuery(e.currentTarget).parent().find('.header-dropdown'); // e.currentTarget works for both keyboard and click
				// Check if dropdown should be closed
				if (dropdown.hasClass('header-dropdown--active'))
				{
					// Hide dropdown
					fn.headerDropdownHide(dropdown);
				} else {
					// Show Dropdown
					jQuery(e.currentTarget).attr('aria-expanded', true);
					// Hide Other Dropdowns
					jQuery('.header-dropdown--active').each(function()
					{
						var activeDropdown = jQuery(this);
						fn.headerDropdownHide(activeDropdown);
					});
					// Show Selected Dropdown
					fn.headerDropdownShow(dropdown);
				}
			},

			headerDropdownCloseAll: function()
			{
				jQuery('.e-toggle-dropdown').attr('aria-expanded', false);
				jQuery('.header-dropdown--active').each(function()
				{
					var activeDropdown = jQuery(this);
					fn.headerDropdownHide(activeDropdown);
				});
			},

			headerDropdownShow: function(dropdown)
			{
				dropdown.show();
				// Mobile class added
				dropdown.closest('.mobile-nav-group').addClass('mobile-nav-group--open');

				// Calculate height of 'top'
				var offset = jQuery('header').height();

				if (jQuery('body').hasClass('logged-in'))
				{
					var adminbarOffset = jQuery('#wpadminbar').height();
					offset = offset + adminbarOffset;
				}

				dropdown.parent('.header-dropdown-positioner').css('top', offset + 'px');

				dropdown.addClass('header-dropdown--active');
				// Allow Submenu items to be tabbed
				dropdown.find('.tabbed, a.button').attr('tabindex', '0');
			},

			headerDropdownHide: function(dropdown)
			{
				dropdown.removeClass('header-dropdown--active');
				dropdown.find('.tabbed, a.button').attr('tabindex', '-1');
				// Delay hiding dropdown on desktop menu
				if (jQuery('.mobile-nav-menu-btn').is(':visible'))
				{
					var timeoutDuration = "0";
				}
				else
				{
					var timeoutDuration = "500";
				}
				setTimeout(() =>
				{
					dropdown.closest('.mobile-nav-group').removeClass('mobile-nav-group--open');
					dropdown.parent('.header-dropdown-positioner').css('top', '-10000px');
					dropdown.hide();
				}, timeoutDuration);
			},


			// Footer Menu Toggle
			handleMobileFooterMenuExpansion: function(e)
			{
				e.preventDefault();
				var footerMenuButton = jQuery(this);
				var footermenuContainer = footerMenuButton.closest('.footer-menu--mobile-dropdown');
				var footerMenuContents = footermenuContainer.find('nav');

				if (footerMenuContents.is(":visible"))
				{
					footermenuContainer.removeClass('active');
					footerMenuContents.hide(200);
				}
				else
				{
					footermenuContainer.addClass('active');
					footerMenuContents.show(200);
				}
			},


			// Accordion Toggle
			accordionToggle: function(event)
			{
				var accordionButton = jQuery(event.currentTarget);
				var accordionContent = accordionButton.siblings('.accordion__content');
				if (accordionButton.hasClass('accordion-open'))
				{
					// Hide Accordion
					accordionContent.slideUp('300');
					accordionButton.removeClass('accordion-open');
					accordionButton.attr('aria-expanded', 'false');
					GlossaryPopup.pauseVideoPlayerOnClose(accordionContent); // if accordion contains iframe
				} else {
					// Show Dropdown
					accordionContent.slideDown('300');
					accordionButton.addClass('accordion-open');
					accordionButton.attr('aria-expanded', 'true');
				}
			},

			// Better Tabbing - to prevent destination appearing under fixed header
			betterTabbing: function(e)
			{
				if(jQuery('.page-template-template-rexx').length) {
					return;
				}
				var element = jQuery(this);
				var headerHeight = jQuery('header').height();
				var offsetHeight = headerHeight + 25;
				if (element.offset().top - jQuery(window).scrollTop() < offsetHeight)
				{
					jQuery('html, body').animate({
						scrollTop: element.offset().top - offsetHeight
					}, 250);
				}
			},


			// Scroll to Top of Form Assembly forms - rewrite the wForms scrolling
			scrollToFormTop: function(e)
			{
				var element = jQuery('.wForm');
				var headerHeight = jQuery('header').height();
				var offsetHeight = headerHeight + 25;
				jQuery('html, body').animate({
					scrollTop: element.offset().top - offsetHeight
				}, 250);
			},


			// Slick Slider
			testimonialSlider: function(i, slider)
			{
				jQuery(slider).on('init', function(event, slick) {
					jQuery(this).find('.testimonials__slide').show();
				});
				jQuery(slider).slick({
					lazyLoad: 'progressive',
					infinite: true,
					dots: true,
					arrows: false
				});
			},

			logoSlider: function(i, slider)
			{
				jQuery(slider).on('init', function(event, slick) {
					jQuery(this).find('img').show();
				});

				jQuery(slider).slick({
					lazyLoad: 'progressive',
					slidesToShow: 5,
					slidesToScroll: 1,
					infinite: true,
					dots: false,
					autoplay: true,
					autoplaySpeed: 2000,
					arrows: false, // we're adding our own arrows
					responsive: [
						{
							breakpoint: 1290,
							settings: {
							  slidesToShow: 4,
							  slidesToScroll: 1,
							  infinite: true,
							}
						},
						{
							breakpoint: 1070,
							settings: {
							  slidesToShow: 3,
							  slidesToScroll: 1,
							  infinite: true,
							}
						},
						{
						  breakpoint: 800,
						  settings: {
							slidesToShow: 2,
							slidesToScroll: 1,
							infinite: true,
						  }
						},
						{
						  breakpoint: 543,
						  settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
							infinite: true,
						  }
						}
					]
				});

				jQuery(slider).parent().find('.js-logos-prev').on('click', function(){
					jQuery(slider).slick('slickPrev');
				});

				jQuery(slider).parent().find('.js-logos-next').on('click', function(){
					jQuery(slider).slick('slickNext');
				});
			},

			// Pagination - Goto Page Form Submit
			paginationGoto: function(e)
			{
				e.preventDefault();
				var form = jQuery(this);
				var fieldURL = form.find(':input[name="goto-url"]');
				var fieldNum = form.find(':input[name="goto-number"]');
				var fieldLetter = form.find(':input[name="goto-letter"]');

				if (fieldURL && fieldNum)
				{
					var url = fieldURL[0].value;
					var num = fieldNum[0].value;

					// If 'page' segment of url is languaged then will have to change to non-permalinked url
					//window.location.replace(url + 'page/' + num);
					if (fieldLetter)
					{
						var letter = fieldLetter[0].value;
						window.location.replace(url + num + letter);
					}
					else
					{
						window.location.replace(url + num);
					}
				}
			},

			// Post Teaser Grid

			// Filter News
			handleNewsFilter: function(event)
			{
				var filter = jQuery(event.currentTarget);
				var type = filter.data('variation-slug');
				// On first click of filter grid set all posts to filtered hide
				if (!jQuery('.filter__button--active').length)
				{
					jQuery('.post-teaser-grid .col:not([data-variation-type=subscribe])').attr('data-filtered-hide', true);
				}
				// Change visual state of button
				filter.toggleClass('filter__button--active');
				// Change Status of button
				filter.data('active', !filter.data('active'));
				// Toggle filter status of filtered posts
				var typePosts = jQuery('.post-teaser-grid .col[data-variation-type="' + type  + '"]');
				typePosts.each(function()
				{
					var status = jQuery(this).attr('data-filtered-hide') == 'true';
					jQuery(this).attr('data-filtered-hide', !status);
				});
				// Hide all posts
				jQuery('.post-teaser-grid .col').each(function()
				{
					fn.hideTeaser(jQuery(this));
				});
				// Show limited posts
				var showMoreCount = jQuery('.post-teaser-more-button').data('show-count');
				if (!jQuery('.filter__button--active').length)
				{ // If no filters are chosen then revert to original order
					fn.sortTeasersByOrigOrder();
					var hiddenPosts = jQuery('.post-teaser-grid .col:lt(' + showMoreCount + ')');
				}
				else
				{ // If filter(s) chosen then date-order and show relevant posts
					fn.sortTeasersByDate();
					var hiddenPosts = jQuery('.post-teaser-grid .col[data-filtered-hide=false]:lt(' + showMoreCount + ')');
				}
				// Show selected posts
				hiddenPosts.each(function()
				{
					fn.showTeaser(jQuery(this));
				});
				// Hide show more button if no more hidden elements
				fn.updateShowMoreButton();
			},

			// Sort Teasers by date
			sortTeasersByDate: function()
			{
				var $teaser_grid = jQuery('.post-teaser-grid');

				// Move subscribe and featured to front
				$teaser_grid.find('[data-variation-type="subscribe"]').appendTo($teaser_grid);
				$teaser_grid.find('[data-featured="true"]').appendTo($teaser_grid);

				// Sort the rest by timestamp
				$teaser_grid.children('.col:not([data-variation-type="subscribe"]):not([data-featured="true"])').sort(function(a, b) {
					return +b.dataset.timestamp - +a.dataset.timestamp;
				}).appendTo($teaser_grid);
			},

			// Sort Teasers by original order
			sortTeasersByOrigOrder: function()
			{
				var $teaser_grid = jQuery('.post-teaser-grid');
				$teaser_grid.children('.col').sort(function (a, b) {
						return +a.dataset.origorder - +b.dataset.origorder;
				}).appendTo($teaser_grid);
			},

			// Show More Button Click
			handleShowMoreNews: function()
			{
				var showMoreCount = jQuery('.post-teaser-more-button').data('show-count');
				// Find hidden posts
				// Find hidden posts
				if (!jQuery('.filter__button--active').length)
				{ // If no filters are chosen
					var hiddenPosts = jQuery('.post-teaser-grid .col-hide:lt(' + showMoreCount + ')');
				}
				else
				{ // If filter(s) chosen
					var hiddenPosts = jQuery('.post-teaser-grid .col-hide[data-filtered-hide=false]:lt(' + showMoreCount + ')');
				}
				// Show hidden posts
				hiddenPosts.each(function()
				{
					fn.showTeaser(jQuery(this));
				});
				// Hide show more button if no more hidden elements
				fn.updateShowMoreButton();
			},

			// Hide Post Teasers
			hideTeaser: function(item)
			{
				item.addClass('col-hide');
				item.addClass('col-loading');
			},

			// Show Post Teasers
			showTeaser: function(item)
			{
				item.removeClass('col-hide');
				setTimeout(() =>
				{
					item.removeClass('col-loading');
				}, 750);
			},

			// Update Show More Posts Button
			updateShowMoreButton: function()
			{
				if (!jQuery('.filter__button--active').length)
				{ // No filters chosen
					var hiddenPostsCount = jQuery('.post-teaser-grid .col-hide').length;
				}
				else
				{ // Filters chosen
					var hiddenPostsCount = jQuery('.post-teaser-grid .col-hide[data-filtered-hide=false]').length;
				}

				if (hiddenPostsCount > 0)
				{
					jQuery('.post-teaser-more').show();
				}
				else
				{
					jQuery('.post-teaser-more').hide();
				}
			},


			// News Side Bar Clone - for mobile
			cloneSideBar: function()
			{
				var sidebar = jQuery('.post-intro__clone-to-bottom');
				if (sidebar.length)
				{
					jQuery('.post-intro__side-col-dest').append(sidebar.clone());
				}
				else
				{
					jQuery('.post-intro__side-col-mobile').remove();
				}
			},

			/**
			 * Modals --
			 * Includes general and portal-specific modal handling, imported (with adjustments) from 2017 site.
			 *
			 * openGenericModal/ closeGenericModal currently only required by portal modal functions,
			 * but kept separate in case non-portal modals added in future.
			 */
			openGenericModal: function(element)
			{
				global.modals.focusedElementBeforeOpened = document.activeElement;
				global.modals.element = element;
				var lastFocusable = jQuery(element).find('input, button, select, a').last();

				if (lastFocusable)
				{
					global.modals.lastFocusable = lastFocusable[0];
				}

				jQuery(global.modals.element).removeAttr('hidden');

				var initFocus = jQuery(global.modals.element).find('.js-init-focus');

				if (initFocus.length && (jQuery(window).width() > 800))
				{
					initFocus[0].focus();
				}
				else
				{
					global.modals.element.focus();
				}

				jQuery('.page-container').attr('aria-hidden', 'true');
			},

			closeGenericModal: function()
			{
				var element = global.modals.element;
				global.modals.element = false;

				// Show the page to a11y tree again
				jQuery('.page-container').attr('aria-hidden', 'false');

				// Return focus to where it was before we opened the dialog
				if (global.modals.focusedElementBeforeOpened)
				{
					global.modals.focusedElementBeforeOpened.focus();
				}

				// Show the modal
				jQuery(element).attr('hidden', 'true');
			},

			modalKeyboardEvents: function(e)
			{
				if (!global.modals.element)
				{
					return;
				}

				// Esc key
				if ( e.keyCode && e.keyCode === 27)
				{
					if (jQuery('.js-portal-modal').length)
					{
						fn.dismissPortalModal(e);
					}
					else
					{
						fn.closeGenericModal();
					}
				}
				// Enter key
				if (!global.modals.lastFocusable && e.keyCode && e.keyCode === 13)
				{
					fn.closeGenericModal();
				}

				// Tab key
				if ( e.keyCode && e.keyCode === 9)
				{
					if (global.modals.lastFocusable)
					{
						if ( global.modals.lastFocusable && (e.target == global.modals.lastFocusable))
						{
							e.stopPropagation();
							global.modals.element.focus();
						}
					}
					else
					{
						e.preventDefault();
					}
				}
			},

			closePortalModal: function(event)
			{
				event.preventDefault();
				var modal = jQuery('.js-portal-modal');
				fn.closeGenericModal(modal[0]);
			},

			recordPortalNotificationsPreference: function(preferenceType)
			{
				var data = {
					action: 'record_portal_notifications_preference',
					postdata: {
						preferenceType: preferenceType
					}
				};

				jQuery.post(flocertajax, data)
					.done(function( data )
					{
						console.log('success');
					})
					.fail(function( data )
					{
						console.log('AJAX error with data : '+ data);
					});
			},

			dismissPortalModal: function(event)
			{
				if (jQuery('.js-portal-modal').data('preference') !== 'OPTIN')
				{
					fn.recordPortalNotificationsPreference('DISMISS');
				}

				fn.closePortalModal(event);
			},

			declinePortalModal: function(event)
			{
				fn.recordPortalNotificationsPreference('OPTOUT');
				fn.closePortalModal(event);
			},

			consumeEvent: function(event)
			{
				event.stopPropagation();
			}
		}

		jQuery(fn.init);
	}

	new Main();
})(jQuery);